"use strict";
// @todo is that component broken? should it be removed?
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Text_1 = tslib_1.__importDefault(require("../../../../ui-lib/Buttons/Text"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularCallButton = (0, mobx_react_lite_1.observer)(({ buttonRequestText, isFirstAttempt, classes, hideOnAcceptedCall = false, label = "Request call button", onRequestButtonClick, ...props }) => {
    const componentName = "<SendCallRequestButton/>";
    const { store, sendCallRequest, cancelCallRequest } = (0, react_1.useContext)(context_1.EncoderUiContext);
    const toggleCallRequest = () => {
        if (store.requestingCall) {
            cancelCallRequest();
        }
        else {
            sendCallRequest();
        }
    };
    const handleClick = onRequestButtonClick || (0, ErrorBoundary_1.useUIEventError)(toggleCallRequest, componentName);
    if (hideOnAcceptedCall && (store === null || store === void 0 ? void 0 : store.callAccepted)) {
        return null;
    }
    const active = store === null || store === void 0 ? void 0 : store.requestingCall;
    let buttonText;
    if (active) {
        buttonText = "Cancel";
    }
    else if (isFirstAttempt) {
        buttonText = buttonRequestText !== null && buttonRequestText !== void 0 ? buttonRequestText : "Send video call request";
    }
    else {
        buttonText = "Try again";
    }
    const disabled = !store || (store && !store.cameraOn && !store.micOn) || (store === null || store === void 0 ? void 0 : store.disconnectingCall);
    const classNames = "video-button--send-call-request lv-button--send-call-request";
    return (react_1.default.createElement(Text_1.default, { active: active, classNames: classNames, "data-selenium": "video-button--send-call-request-button", disabled: disabled, label: label, onClick: handleClick, ...props }, buttonText));
});
// eslint-disable-next-line react/function-component-definition
const CallButtonWithErrorBoundary = ({ active, classes, buttonRequestText = "Send video call request", label = "Request call button", ...props }) => {
    const classNames = "video-button--send-call-request lv-button--send-call-request";
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => (react_1.default.createElement(Text_1.default, { classNames: classNames, classes: classes, "data-selenium": "video-button--send-call-request-button", disabled: true, label: label, onClick: undefined, ...props }, buttonRequestText)) },
        react_1.default.createElement(ModularCallButton, { classes: classes, buttonRequestText: buttonRequestText, label: label, active: active, ...props })));
};
exports.default = CallButtonWithErrorBoundary;
//# sourceMappingURL=SendCallRequest.js.map